/*
 * Copyright (c) 2023. Nedaware SL
 */

import {BasicEntity, BasicProperty} from "../../basic-entity-back/annotations";
import {PropertyType} from "../../basic-entity-back/property-type/property-type";
import {NestedBehavior} from "../../basic-entity-back/property-type/nested-model-type";
import {DescuentoGeneral} from "./descuento-general.model";
import {Resource} from "../../api/resource";
import {ReadWrite} from "../../basic-entity-back/basic-entity-interface/mapping-external";

@BasicEntity({
    name: 'Descuento general para el cliente',
    endpoint: 'descuento_general_cliente_rels',
    isPaginated: true,
    acceptsBulkIriSearch: true,
    paginationSizes: [20, 30, 50],
    modelNameProperty: 'descripcion',
    type: 'DescuentoGeneralClienteRel'
})
export class DescuentoGeneralClienteRel extends Resource {
    static readonly TIPO_DESCUENTO = {
        PORCENTAJE: '%',
        PRECIO: "€",
    };

    @BasicProperty({
        name: 'ID',
        isId: true,
        type: PropertyType.Integer()
    })
    private _id;

    @BasicProperty({
        name: 'Descuento',
        type: PropertyType.Float()
    })
    private _descuento = 0.0;

    @BasicProperty({
        name: 'Tipo descuento',
        type: PropertyType.Choice(...Object.values(DescuentoGeneralClienteRel.TIPO_DESCUENTO)),
        sortable: true
    })
    private _tipoDescuento;

    @BasicProperty({
        name: 'Descuento',
        type: PropertyType.NestedModel(DescuentoGeneral, null, NestedBehavior.SendIriOnly)
    })
    private _descuentoGeneral;

    @BasicProperty({
        name: 'Aplicar automáticamente al facturar',
        type: PropertyType.Boolean()
    })
    private _aplicarAlFacturar = false;

    get descripcion() {
        return this.descuentoGeneral.descripcion + ' (' + this._descuento + this._tipoDescuento + ')';
    }

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get descuento() {
        return this._descuento;
    }

    set descuento(value) {
        this._descuento = value;
    }

    get descuentoGeneral() {
        return this._descuentoGeneral;
    }

    set descuentoGeneral(value) {
        this._descuentoGeneral = value;
    }

    get aplicarAlFacturar(): boolean {
        return this._aplicarAlFacturar;
    }

    set aplicarAlFacturar(value: boolean) {
        this._aplicarAlFacturar = value;
    }

    get tipoDescuento() {
        return this._tipoDescuento;
    }

    set tipoDescuento(value) {
        this._tipoDescuento = value;
    }
}

